import { computed, makeObservable } from "mobx";
import { inject, observer } from "mobx-react";
import { Component } from "react";
import { FormattedMessage, type IntlShape, injectIntl } from "react-intl";
import { compose } from "nvent-web/utils/compose";

import ThermostatForm from "nvent-web/components/AddThermostatForm/AddThermostatForm";
import * as logger from "nvent-web/services/logger";
import { NotificationsStore } from "nvent-web/stores/Notifications";
import { ProductsStore } from "nvent-web/stores/Products";
import { type AddProductParams } from "nvent-web/types/AddProductParams";
import { withRouter, type WithRouterProps } from "~/nvent-web/utils/withRouter";

interface FormValues {
  productSkuId: string;
}
interface AddThermostatFormProps {
  onClose: () => void;
}

interface AddThermostatFormInnerProps
  extends AddThermostatFormProps, WithRouterProps, AddProductParams {
  intl: IntlShape;
  products: ProductsStore;
  notifications: NotificationsStore;
}

class AddThermostatFormInner extends Component<AddThermostatFormInnerProps> {
  constructor(props: AddThermostatFormInnerProps) {
    super(props);

    makeObservable(this, {
      thermostatSkuOptions: computed,
    });
  }

  get thermostatSkuOptions() {
    return this.props.products.availableThermostatSkus.map(
      ({ id, description }) => ({
        key: id.toString(),
        title: description,
      })
    );
  }

  render() {
    const { products } = this.props;
    const isSubmitting = products.isProductCreating;

    return (
      <ThermostatForm
        isSubmitting={isSubmitting}
        onSubmit={this.handleSubmit}
        onCancel={this.handleCancel}
        thermostatOptions={this.thermostatSkuOptions}
      />
    );
  }

  private handleCancel = () => {
    this.props.onClose();
  };

  private handleSubmit = async ({ productSkuId }: FormValues) => {
    const {
      products,
      params: { projectId, roomId },
      notifications,
    } = this.props;

    try {
      await products.createProductSku(Number(projectId), Number(roomId), {
        productSkuId: Number(productSkuId),
      });
      this.props.onClose();
    } catch (error) {
      logger.error(error);
      notifications.createError(
        <FormattedMessage id="error.productUnavailable" />
      );
    }
  };
}

const AddThermostatForm = compose<AddThermostatFormProps>(
  injectIntl,
  inject("products", "notifications"),
  observer,
  withRouter
)(AddThermostatFormInner);

export default AddThermostatForm;
